import React, { useRef } from "react";
import { connect } from "react-redux";

import { setActiveEmailTemplate, sendAccountEmail, fetchAccount } from "actions";
import { accountsSelector, emailTemplateSelector, loginInfoSelector, selectedAccountsSelector } from "reducers";
import { EMAIL_TEMPLATE_TYPES } from "../../admin/constants";
import { SendEmailForm } from "components/forms";

const SendAccountEmailForm = ({ mail, ...props }) => {
  React.useEffect(() => {
    if (props.selectedAccounts) {
      for (let id of props.selectedAccounts) {
        let account = props.accounts.find(item => item.id === id);
        if (!account) {
          props.fetchAccount(id);
        }
      }
    }
  }, []);

  const getSelectedEmails = email_source => {
    if (props.selectedAccounts) {
      let result = "";
      for (let id of props.selectedAccounts) {
        let account = props.accounts.find(item => item.id === id);
        if (account) {
          if (email_source === "Work Email") {
            result += account.source_name + " <" + (account.work_email || "") + ">; ";
          } else if (email_source === "Case Status Email") {
            result += account.source_name + " <" + (account.email || "") + ">; ";
          } else if (email_source === "Other Email") {
            result += account.source_name + " <" + (account.other_email || "") + ">; ";
          } else if (email_source === "Other Email #2") {
            result += account.source_name + " <" + (account.other_email2 || "") + ">; ";
          }
        }
      }
      return result;
    } else {
      return "";
    }
  };

  return (
    <SendEmailForm
      onSubmitAction={props.sendAccountEmail}
      emailTemplates={props.emailTemplates}
      getSelectedEmails={getSelectedEmails}
      loginInfo={props.loginInfo}
      selectedIds={props.selectedAccounts}
      templateType="Accounts"
      title="Send Account Email"
      mail={mail}
    />
  );
};

const mapStateToProps = state => {
  const accounts = accountsSelector(state);
  const emailTemplates = emailTemplateSelector(state).filter(
    template => template.type === EMAIL_TEMPLATE_TYPES.ACCOUNT,
  );

  return {
    loginInfo: loginInfoSelector(state),
    accounts,
    selectedAccounts: selectedAccountsSelector(state),
    emailTemplates,
  };
};

export default connect(mapStateToProps, {
  setActiveEmailTemplate,
  sendAccountEmail,
  fetchAccount,
})(SendAccountEmailForm);
